import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

declare global {
  interface Window {
    __qrokePatchedRemoveChild?: boolean;
  }
}

if (!window.__qrokePatchedRemoveChild) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (this: Node, child: Node): Node {
    try {
      return originalRemoveChild.call(this, child);
    } catch (error: any) {
      const message = String(error?.message || '').toLowerCase();
      const isNotFound = error?.name === 'NotFoundError' || message.includes('not a child of this node');
      if (isNotFound) {
        return child;
      }
      throw error;
    }
  };
  window.__qrokePatchedRemoveChild = true;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
)